import storageHelper from './storageHelper';

export function notifyForDashboard(id) {
  if (global.window && window.parent) {
    const message = {
      key: 'dashboard',
      value: id
    };

    window.parent.postMessage(message, '*');
    for (let f = 0; f < window.parent.frames.length; f++) {
      window.parent.frames[f].postMessage(message, '*');
    }
  }
}

export function notifyForToken(token) {
  const message = {
    key: 'auth-token',
    value: token
  };

  //add chrome check
  if (!!window && /Safari/.test(navigator.userAgent)) {
    storageHelper.storage().setItem('token', token);
  }

  window.parent.postMessage(message, '*');
  for (let f = 0; f < window.parent.frames.length; f++) {
    window.parent.frames[f].postMessage(message, '*');
  }
}

export default {
  notifyForDashboard,
  notifyForToken
};
